var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SfCheckbox',_vm._b({staticClass:"PfCheckbox",on:{"change":_vm.changeHandler,"input":_vm.inputHandler},scopedSlots:_vm._u([{key:"checkmark",fn:function(ref){
var isChecked = ref.isChecked;
return [_c('span',{staticClass:"sf-checkbox__checkmark",class:{ 'is-active': isChecked }},[(isChecked)?_c('i',{staticClass:"fas mgz-fa-check"}):_vm._e()])]}}])},'SfCheckbox',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }